<div class="row" *ngIf="isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                    floatLabel="{{formFieldFloatLabel}}">
                                    <mat-label class="InputLabelColor">Criado por</mat-label>
                                    <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="40"
                                        formControlName="criado_por" readonly class="InputBlockColor">
                                    <i matSuffix class="{{iconDisableField}}"></i>
                                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                    <mat-hint align="end">{{txtCriadoPor.value.length}} / 40</mat-hint>
                                    <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}
                                    </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Usuário</mat-label>
                                <input matInput id="txtUsuario" #txtUsuario maxlength="100" formControlName="usuario"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtUsuario.value.length}} / 100</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.usuario)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Observação</mat-label>
                                <textarea matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="observacoes"></textarea>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacoes)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>
<div class="row" *ngIf="isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                    floatLabel="{{formFieldFloatLabel}}">
                                    <mat-label class="InputLabelColor">Criado por</mat-label>
                                    <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="40"
                                        formControlName="criado_por" readonly class="InputBlockColor">
                                    <i matSuffix class="{{iconDisableField}}"></i>
                                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                    <mat-hint align="end">{{txtCriadoPor.value.length}} / 40</mat-hint>
                                    <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}
                                    </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Usuário</mat-label>
                                <input matInput id="txtUsuario" #txtUsuario maxlength="100" formControlName="usuario"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtUsuario.value.length}} / 100</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.usuario)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Observação</mat-label>
                                <textarea matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="observacoes"></textarea>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacoes)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>